import { Link } from 'react-router-dom';
import Logo from '../../../components/feature/Logo';

const NAV_LINKS = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Sobre Nosotros', href: '#sobre-nosotros' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Cómo Funciona', href: '#como-funciona' },
  { label: 'Testimonios', href: '#testimonios' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contacto', href: '#contacto' },
];

const SERVICES_LINKS = [
  'Mediación Familiar',
  'Mediación Civil y Mercantil',
  'Mediación Laboral',
  'Mediación Bancaria',
  'Mediación Escolar',
  'Mediación Comunitaria',
];

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id.replace('#', ''));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0D2137] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer mb-4">
              <Logo variant="light" />
            </Link>
            <p className="text-white/55 text-sm leading-relaxed">
              Mediadores certificados por el Ministerio de Justicia. Resolución de conflictos de forma profesional, rápida y confidencial desde 2015.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-youtube-fill', href: '#' },
                { icon: 'ri-twitter-x-line', href: '#' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/8 hover:bg-[#3D9E8C] transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4">
              <a id="footer-nav" href="#inicio">Navegación</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}
                    className="text-white/55 text-sm hover:text-[#3D9E8C] transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4">
              <a id="footer-services" href="#servicios">Servicios</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {SERVICES_LINKS.map((s) => (
                <li key={s}>
                  <a
                    href="#servicios"
                    onClick={(e) => { e.preventDefault(); scrollTo('#servicios'); }}
                    className="text-white/55 text-sm hover:text-[#3D9E8C] transition-colors cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="font-semibold text-white text-sm mb-4">
              <a id="footer-contact" href="#contacto">Contacto</a>
            </h4>
            <ul className="flex flex-col gap-4">
              {[
                { icon: 'ri-map-pin-line', text: 'C/ Zurbano 96, 6º Derecha, 28003 Madrid' },
                { icon: 'ri-phone-line', text: '(+34) 696 342 047' },
                { icon: 'ri-mail-line', text: 'jlarrache@mediatioglobal.com' },
                { icon: 'ri-time-line', text: 'Lun–Vie: 9:00 – 20:00h' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <i className={`${item.icon} text-[#3D9E8C] text-base mt-0.5 flex-shrink-0`} />
                  <span className="text-white/55 text-sm leading-relaxed">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/35 text-xs">
            © {new Date().getFullYear()} Mediatio Global S.L. — Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/politica-de-privacidad" className="text-white/35 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">Política de Privacidad</Link>
            <Link to="/aviso-legal" className="text-white/35 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">Aviso Legal</Link>
            <Link to="/politica-de-cookies" className="text-white/35 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
